export default __webpack_public_path__ + "img/4e8df464427fe92736aca2658caa1fb2.svg";